import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Badge } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { IRegistration } from '../../../store/registrations/interfaces'
import { updatePriority } from '../../../store/registrations/registrations'
import { RootState } from '../../../store'
import { isTabletOrMobileQuery, isTabletOrSmallDesktopQuery } from '../../../utils'
import { useMediaQuery } from 'react-responsive'

const Priority = (props: {
  registration: IRegistration
  editable: boolean
}) => {
  const dispatch = useDispatch()
  const { registration, editable } = props
  const incrementPriority = () =>
    dispatch(
      updatePriority({ eventId: registration.event.event_id, dPriority: +1 }),
    )
  const decrementPriority = () =>
    dispatch(
      updatePriority({ eventId: registration.event.event_id, dPriority: -1 }),
    )

  const isTabletOrMobile = useMediaQuery(isTabletOrMobileQuery)
  const isTabletOrSmallDesktop = useMediaQuery(isTabletOrSmallDesktopQuery)

  const { list: registrations } = useSelector(
    (state: RootState) => state.registrations,
  )
  const { loadedViaCode } = useSelector((state: RootState) => state.misc)
  const [isLast] = React.useState(
    registration.priority === registrations.length - 1,
  )
  const [isFirst] = React.useState(registration.priority === 0)

  const leftOrDown =
    isTabletOrMobile || isTabletOrSmallDesktop ? 'Down' : 'Left'
  const rightOrUp = isTabletOrMobile || isTabletOrSmallDesktop ? 'Up' : 'Right'

  let animationClassLeft = leftOrDown
  let animationClassRight = rightOrUp

  const incrementRegistrationSibling = (): IRegistration[] =>
    registrations.filter((reg: IRegistration) => {
      if (
        registrations.length === 2 &&
        registration.priority === 0 &&
        reg.priority !== 0
      ) {
        animationClassRight = leftOrDown
        animationClassLeft = rightOrUp
        return true
      } else if (registration.priority === 0 && reg.priority !== 0) {
        animationClassLeft = rightOrUp
        return true
      } else {
        return reg.priority === registration.priority - 1
      }
    })

  const decrementRegistrationSibling = (): IRegistration[] =>
    registrations.filter((reg: IRegistration) => {
      if (
        registrations.length === 2 &&
        registration.priority === registrations.length - 1 &&
        reg.priority === 0
      ) {
        animationClassRight = leftOrDown
        animationClassLeft = rightOrUp
        return true
      } else if (
        reg.priority !== registrations.length - 1 &&
        registration.priority === registrations.length - 1
      ) {
        animationClassRight = leftOrDown
        return true
      } else {
        return reg.priority === registration.priority + 1
      }
    })
  return (
    <span
      className={`d-flex align-items-center ${
        isTabletOrMobile ? '' : 'justify-content-between'
      }`}
    >
      Priorität&nbsp;
      <div className='d-flex align-items-center ml-5'>
        {loadedViaCode ? (
          <></>
        ) : (
          <button
            className='mr-2 my-0 text-dark h2 border-0 bg-transparent'
            aria-label='Priorität der Anmeldung verringern'
            onClick={() => {
              if (editable && registrations.length > 1 && !isFirst) {
                animateCard(
                  registration.event.event_id,
                  incrementRegistrationSibling(),
                  animationClassLeft,
                  animationClassRight,
                )
                incrementPriority()
              }
            }}
          >
            <FontAwesomeIcon
              color={
                editable && registrations.length > 1 && !isFirst
                  ? undefined
                  : 'transparent'
              }
              icon={
                isTabletOrMobile || isTabletOrSmallDesktop
                  ? 'caret-up'
                  : 'caret-left'
              }
              role='presentation'
              size='lg'
            />
          </button>
        )}
        <h4 style={{ overflow: 'auto' }}>
          <Badge className='dark-primary-background' pill variant='primary'>
            {registration.priority + 1}
          </Badge>
        </h4>
        {loadedViaCode ? (
          <></>
        ) : (
          <button
            className='ml-2 my-0 text-dark h2 border-0 bg-transparent'
            aria-label='Priorität der Anmeldung erhöhen'
            disabled={loadedViaCode}
            onClick={() => {
              if (editable && registrations.length > 1 && !isLast) {
                animateCard(
                  registration.event.event_id,
                  decrementRegistrationSibling(),
                  animationClassRight,
                  animationClassLeft,
                )
                decrementPriority()
              }
            }}
          >
            <FontAwesomeIcon
              color={
                editable && registrations.length > 1 && !isLast
                  ? undefined
                  : 'transparent'
              }
              icon={
                isTabletOrMobile || isTabletOrSmallDesktop
                  ? 'caret-down'
                  : 'caret-right'
              }
              role='presentation'
              size='lg'
            />
          </button>
        )}
      </div>
    </span>
  )
}

export default Priority

const animateCard = (
  event_id: number,
  sibling_registrations: IRegistration[],
  direction: string,
  sibling_direction: string,
) => {
  /* we have to get the cards inside the slick-active, 
  because slick js create clones of our cards and the animations 
  won't work if the infinite slick-slider is created */
  const cardElement: HTMLElement = document.querySelector(
    '.slick-slide:not(.slick-cloned) div #reg-card-' + event_id,
  ) as HTMLFormElement

  cardElement.classList.add('animated', 'slideIn' + direction, 'faster')
  setTimeout(() => {
    cardElement.classList.remove('animated', 'slideIn' + direction, 'faster')
  }, 1000)

  sibling_registrations
    .map(reg =>
      document.querySelector(
        '.slick-slide:not(.slick-cloned) div #reg-card-' + reg.event.event_id,
      ),
    )
    .forEach(elem => {
      if (elem) {
        elem.classList.add('animated', 'slideIn' + sibling_direction, 'faster')
        setTimeout(() => {
          elem.classList.remove(
            'animated',
            'slideIn' + sibling_direction,
            'faster',
          )
        }, 1000)
      }
    })
}
